import ProportionLayout from './ProportionLayout';
import ChartUtilities from './ChartUtilities';
import { ReactNode, useState } from 'react';

interface IProps {
	page: string;
	title: string | ReactNode;
	text: string | ReactNode;
	topic: string;
}
const ProportionSection = ({ ...props }: IProps) => {
	const [accordionIndex, setAccordionIndex] = useState<number | null>(null);

	return (
		<>
			<ProportionLayout
				{...props}
				accordionIndex={accordionIndex}
				setAccordionIndex={setAccordionIndex}
			/>
			<ChartUtilities
				component={
					<ProportionLayout
						{...props}
						accordionIndex={accordionIndex}
						setAccordionIndex={setAccordionIndex}
						print={true}
					/>
				}
				title={props.title}
				page={props.page}
			/>
		</>
	);
};

export default ProportionSection;
